import * as KlueTypes from '../../klue_types';

export const company = companyInfo => KlueTypes.Company.create({info: companyInfo});
